const upperCaseCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
const lowerCaseCharacters = "abcdefghijklmnopqrstuvwxyz"
const numericCharacters = "1234567890"
const specialCharacters = `~!@#$%^&*()_+=-[]{};:'"<>,.?\`/\\`

function validatePassword(password) {
	let checkUpper = false;
	let checkLower = false;
	let checkNumber = false;
	let checkSpecial = false;
	let notAllowCharacter = false;

	[...password].forEach((v,i)=> {
		if ([...upperCaseCharacters].includes(v)){
			checkUpper=true
		}
		else if ([...lowerCaseCharacters].includes(v)){
			checkLower=true
		}
		else if ([...numericCharacters].includes(v)){
			checkNumber=true
		}
		else if ([...specialCharacters].includes(v)){
			checkSpecial=true
		} else {
			notAllowCharacter = true
		}
	})
	return checkUpper && checkLower && checkNumber && checkSpecial && !notAllowCharacter
}

export default validatePassword
